import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';


const UpdateCompanyDetails = () => {
  const [gstCertificate, setGstCertificate] = useState(null);
  const [panNumber, setPanNumber] = useState('');
  const [tanNumber, setTanNumber] = useState('');
  const [incorporationCertificate, setIncorporationCertificate] = useState(null);
  const [cancelCheque, setCancelCheque] = useState(null);
  const [signatureForInvoice, setSignatureForInvoice] = useState(null);

  const handleGstCertificateChange = (e) => setGstCertificate(e.target.files[0]);
  const handleIncorporationCertificateChange = (e) => setIncorporationCertificate(e.target.files[0]);
  const handleCancelChequeChange = (e) => setCancelCheque(e.target.files[0]);
  const handleSignatureForInvoiceChange = (e) => setSignatureForInvoice(e.target.files[0]);
  const handlePanNumberChange = (e) => setPanNumber(e.target.value);
  const handleTanNumberChange = (e) => setTanNumber(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("gstCertificate", gstCertificate);
    formData.append("panNumber", panNumber);
    formData.append("tanNumber", tanNumber);
    formData.append("incorporationCertificate", incorporationCertificate);
    formData.append("cancelCheque", cancelCheque);
    formData.append("signatureForInvoice", signatureForInvoice);

    // Handle the form submission logic (e.g., sending the data to a server)
    console.log({
      gstCertificate,
      panNumber,
      tanNumber,
      incorporationCertificate,
      cancelCheque,
      signatureForInvoice,
    });

    // Reset form after submission
    setGstCertificate(null);
    setPanNumber('');
    setTanNumber('');
    setIncorporationCertificate(null);
    setCancelCheque(null);
    setSignatureForInvoice(null);
  };

  return (
    <Container
      style={{
      //  background: 'linear-gradient(135deg, #6e7dff, #4458e8)',
        minHeight: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: '900px',
          borderRadius: '10px',
          padding: '30px',
          backgroundColor: '#fff',
          boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: '30px', fontFamily: 'Arial, sans-serif' }}>Update Documents</h2>
        <Form onSubmit={handleSubmit}>
          {/* Row 1: GST Certificate and PAN Number */}
          <Row className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col xs={12} md={5} style={{ marginBottom: '20px' }}>
              <Form.Label style={{ display: 'block', textAlign: 'left', fontWeight: 'bold' }}>GST Certificate</Form.Label>
              <Form.Control
                type="file"
                onChange={handleGstCertificateChange}
                required
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                  fontSize: '16px',
                }}
              />
            </Col>

            <Col xs={12} md={5} style={{ marginBottom: '20px' }}>
              <Form.Label style={{ display: 'block', textAlign: 'left', fontWeight: 'bold' }}>PAN Number</Form.Label>
              <Form.Control
                type="text"
                value={panNumber}
                onChange={handlePanNumberChange}
                required
                maxLength={10} // PAN Number is typically 10 characters
                pattern="[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}" // Basic PAN format validation
                title="Please enter a valid PAN number"
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                  fontSize: '16px',
                }}
              />
            </Col>
          </Row>

          {/* Row 2: TAN Number and Incorporation Certificate */}
          <Row className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col xs={12} md={5} style={{ marginBottom: '20px' }}>
              <Form.Label style={{ display: 'block', textAlign: 'left', fontWeight: 'bold' }}>TAN Number</Form.Label>
              <Form.Control
                type="text"
                value={tanNumber}
                onChange={handleTanNumberChange}
                required
                maxLength={10} // TAN Number is typically 10 characters
                pattern="[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}" // Basic TAN format validation
                title="Please enter a valid TAN number"
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                  fontSize: '16px',
                }}
              />
            </Col>

            <Col xs={12} md={5} style={{ marginBottom: '20px' }}>
              <Form.Label style={{ display: 'block', textAlign: 'left', fontWeight: 'bold' }}>Incorporation Certificate</Form.Label>
              <Form.Control
                type="file"
                onChange={handleIncorporationCertificateChange}
                required
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                }}
              />
            </Col>
          </Row>

          {/* Row 3: Cancel Cheque and Signature for Invoice */}
          <Row className="mb-3" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col xs={12} md={5} style={{ marginBottom: '20px' }}>
              <Form.Label style={{ display: 'block', textAlign: 'left', fontWeight: 'bold' }}>Cancel Cheque</Form.Label>
              <Form.Control
                type="file"
                onChange={handleCancelChequeChange}
                required
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                }}
              />
            </Col>

            <Col xs={12} md={5} style={{ marginBottom: '20px' }}>
              <Form.Label style={{ display: 'block', textAlign: 'left', fontWeight: 'bold' }}>Signature for Invoice</Form.Label>
              <Form.Control
                type="file"
                onChange={handleSignatureForInvoiceChange}
                required
                style={{
                  display: 'block',
                  margin: '0 auto',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  backgroundColor: '#f9f9f9',
                }}
              />
            </Col>
          </Row>

          <Button
            type="submit"
            variant="primary"
            style={{
              display: 'block',
              margin: '0 auto',
              padding: '12px 30px',
              fontSize: '18px',
              backgroundColor: '#0056b3',
              borderColor: '#0056b3',
              borderRadius: '4px',
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#003d82')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#0056b3')}
          >
            Submit
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default UpdateCompanyDetails